export const primary = 'rgb(37, 99, 235)';
export const level1 = '#1a2332';
export const level2 = '#1a2332';
export const level3 = '#141b28';
